import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useThemeClassName } from '../../contexts/ThemeContext';
import QuestionContainer from '../questions/Question';

import styles from '../../../styles/steps/question.module.scss';

const propTypes = {
    question: PropTypes.shape({
        image: PropTypes.shape({}),
        choices: PropTypes.arrayOf(
            PropTypes.shape({
                image: PropTypes.shape({}),
            }),
        ),
    }),
    isEnded: PropTypes.bool,
    answer: PropTypes.shape({}),
    onAnswer: PropTypes.func,
    isLive: PropTypes.bool,
    isPreview: PropTypes.bool,
    isDisplay: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    innerClassName: PropTypes.string,
};

const defaultProps = {
    question: null,
    isEnded: false,
    answer: null,
    onAnswer: null,
    isLive: true,
    isPreview: false,
    isDisplay: false,
    disabled: false,
    className: null,
    innerClassName: null,
};

function Question({
    question,
    isEnded,
    answer,
    onAnswer,
    isLive,
    isPreview,
    isDisplay,
    disabled,
    className,
    innerClassName,
}) {
    const themeClassName = useThemeClassName(styles);
    const hasQuestionImage = question?.image !== null;
    const hasImageChoices = question?.choices?.some(({ image = null } = {}) => image !== null);

    return (
        <QuestionContainer
            className={classNames([
                styles.container,
                themeClassName,
                { [styles.isDisplay]: isDisplay, [className]: className !== null },
            ])}
            innerClassName={classNames([
                styles.inner,
                { [innerClassName]: innerClassName !== null },
            ])}
            titleClassName={styles.title}
            audioClassName={styles.audio}
            buttonClassName={styles.button}
            question={question}
            answer={answer}
            onAnswer={onAnswer}
            isShuffled={false}
            isEnded={isEnded}
            isLive={isLive}
            isPreview={isPreview}
            autoPlay={isDisplay}
            canPlay={isDisplay}
            layout={hasImageChoices ? 'quad' : null}
            disabled={disabled}
            largeImages={hasQuestionImage && !hasImageChoices && isDisplay}
            isFirstAnswer
        />
    );
}

Question.propTypes = propTypes;
Question.defaultProps = defaultProps;

export default Question;
